'use client';

import { useEffect, useState } from 'react';

import { DevModeIndicator } from './DevModeIndicator';

/**
 * Client component wrapper for DevModeIndicator
 * This component checks environment variables on the client side
 * and passes them to the DevModeIndicator component
 */
export function DevModeIndicatorWrapper() {
  const [isMounted, setIsMounted] = useState(false);
  const [appEnv, setAppEnv] = useState('local');
  const [nodeEnv, setNodeEnv] = useState('development');
  const [isOfflineMode, setIsOfflineMode] = useState(false);
  const [tolgeeDevToolsEnv, setTolgeeDevToolsEnv] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    setAppEnv(process.env.NEXT_PUBLIC_APP_ENV ?? 'local');
    setNodeEnv(process.env.NODE_ENV ?? 'development');
    setIsOfflineMode(process.env.NEXT_PUBLIC_APP_ENV === 'offline');
    setTolgeeDevToolsEnv(process.env.NEXT_PUBLIC_TOLGEE_DEV_TOOLS === 'true');
  }, []);

  // Only show in development mode and after client-side mounting
  if (!isMounted || process.env.NODE_ENV !== 'development') {
    return null;
  }

  // Pass environment variables to the DevModeIndicator component
  return (
    <DevModeIndicator
      appEnv={appEnv}
      nodeEnv={nodeEnv}
      isOfflineMode={isOfflineMode}
      tolgeeDevToolsEnv={tolgeeDevToolsEnv}
    />
  );
}
